import { useCallback } from 'react';
import { dispatcher } from 'dispatcher';
import { usePortletConfig } from 'js/components/system/Portlet';

export const useFavoritesTracking = ({ gameCode, isFavorite, gameFeed }) => {
    const { reactPortletId: container } = usePortletConfig() || {};

    return useCallback(() => dispatcher.dispatch('gameFavoritesChange', {
        container,
        gameFeed,
        gameCode,
        method: !isFavorite ? 'Add' : 'Remove'
    }), [container, gameFeed, gameCode, isFavorite]);
};
